import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import useNotification from "../notifications/useNotifications";

import Modal from "../../layouts/Modal";
import { TextInput } from "../shared/Inputs/TextInput";
import { ButtonInput } from "../shared/Inputs/ButtonInput";

import useWilmaUsers from "../../data/useWilmaUsers";
import { IWilmaUser } from "../../models/auth/WilmaUser";

type FormValues = {
    password: string;
    confirmPassword: string;
};

export default function AdminUserPasswordModal({ open, setOpen, user }: { open: boolean, setOpen: React.Dispatch<React.SetStateAction<boolean>>, user: IWilmaUser | undefined }) {
    const { addNotification } = useNotification();
    const { updatePassword } = useWilmaUsers();
    const [error, setError] = useState<string | null>(null);

    const { handleSubmit, register, reset } = useForm<FormValues>({
        defaultValues: {
            password: "",
            confirmPassword: "",
        }
    });

    useEffect(() => {
        if (open) {
            reset({ password: "", confirmPassword: "" });
            setError(null);
        }
    }, [open, user, reset]);

    const onSubmit = (data: FormValues) => {
        if (!user) return;

        if (!data.password) {
            setError("Please enter a new password");
            return;
        }

        if (data.password !== data.confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        setError(null);

        updatePassword.mutate({ userId: user.id, password: data.password }, {
            onSuccess: () => {
                setOpen(false);
                addNotification({
                    variant: "success",
                    primaryText: "Password updated",
                });
            },
            onError: (err: any) => {
                setError(err?.message || "Failed to update password");
            }
        });
    }

    return (
        <Modal width="max-w-2xl" open={open} setOpen={setOpen} >
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 pt-4">
                <h1 className="text-xl">Change password</h1>
                {user && (
                    <p className="text-sm text-gray-500">{`${user.forename} ${user.surname} (${user.email})`}</p>
                )}
                <TextInput label="New Password" type="password" registerName={"password"} register={register}/>
                <TextInput label="Confirm Password" type="password" registerName={"confirmPassword"} register={register}/>
                {error && <p className="text-sm text-red-500">{error}</p>}
                <ButtonInput label={updatePassword.isLoading ? "Updating..." : "Update Password"} isSubmit disabled={updatePassword.isLoading} />
            </form>
        </Modal>
    )
}
